module.exports = __webpack_public_path__ + "img/9-1.e3473c0f.jpg";